import React from 'react';
import {createTheme, makeStyles, MuiThemeProvider} from '@material-ui/core/styles';
import {Box, Checkbox,  FormControlLabel, Grid, Paper, TextField, Typography} from '@material-ui/core'
import SyncOffice from './syncOffice.png'
import {commonValidation} from "@project/shared/src/services/commonValidation";
import {ApiPostData} from "@project/shared/src/services/ApiPostData";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import {BaseLink,BaseServerWebsite, BaseURL} from "@project/shared/src/services/postData";
import makeAnimated from 'react-select/animated';
import Select from 'react-select';
import MaterialUiButtons from "@project/shared/src/components/button/materialUiButton";

const theme = createTheme({
  overrides: {
    MuiOutlinedInput: {
      root: {
        "&$focused $notchedOutline": {
          border: "1px solid #66afe9 !important",
          outline: 'none',
          boxShadow: "inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, .6) !important"
        },
      },
    },
  },
  typography: {
    fontFamily: [
      '"Montserrat", sans-serif'+'!important'
    ].join(','),
  },
});

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,

    textAlign: 'left',
  },
  saveBtn:{
    background:'#045e06',
    color:'white'
  },
  paper: {
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
    textAlign: 'left',
    color: theme.palette.text.secondary,
  },
  multiselect:props => ({

    marginBottom: '4px',
    position:'relative',
    "& input:focus .css-yk16xz-control":{
      border: "1px solid #66afe9 !important",
      outline: 'none',
      boxShadow: "inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, .6) !important"
    },
    "& .multiSelectLabel":{
      zIndex: '1',
      color: 'rgba(0, 0, 0, 0.54)',
      padding: '0 4px',
      lineHeight: '1',
      letterSpacing: '0.00938em',
      background: props.labelBg!== undefined?props.labelBg:'white',
      marginLeft: '10px',
      marginTop: '-12px',
      position: 'relative',
      top: '6px',
      width: 'max-content'
    },
    "& .css-26l3qy-menu":{
      zIndex:1000
    },
    "& .css-yk16xz-control":{
      borderRadius:props.adornment?'4px 0 0 4px':'4px',
    },
    "&:hover .css-yk16xz-control":{
      border:'1px solid'
    }
  }),

  customTextField: props => ({
    "& >label": {
      // background:'white',
    },
    "& .MuiSelect-icon": {
      position: "inherit",
      cursor: "pointer"
    },
    "&>div>fieldset>legend": {
      background: 'white'
    },
    "& .MuiIconButton-root:focus": {
      outline: "none"
    },
    "& >div>svg": {
      right: props.iconData !== undefined ?
        props.iconData.length === 2 ? 62 : props.iconData.length === 1 ? 41 : props.iconData.length === 3 ? 84 : ""
        : "",
    },
  }),

  phoneInput: {
    position: 'relative',
    "&:hover": {
      "&>div>input": {
        border: '1px solid black',
      },
      "& .flag-dropdown": {
        border: '1px solid black',
      },
    },
    "& .form-control": {
      width: "100%",
      "&:focus": {
        border: "1px solid #66afe9 !important",
        outline: 'none',
        boxShadow: "inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, .6) !important"
      },
      height: '40px'
    }

  },
  errorStyle: {
    color: 'red',
    float: 'left',
    padding: '0 5px',
    transform: 'translate(-5px, 6px) scale(0.75)',
    background: 'white',
    height: 'max-content',
    marginTop: '-19px',
  },
  phoneTextLabel: {
    zIndex: '10',
    position: 'relative',
    background: 'white',
    padding: '0 5px',
    left: '40px',
    color: 'rgba(0, 0, 0, 0.54)',
  }
}));

const contactTroughOption = [
  {
    value: "talk_to_sales",
    label: "Talk to Sales"
  },
  {
    value: "support", label: "Support"
  },
  {
    value: "other",
    label: "Other"
  }

];
const fields = {
  name: {value: '', valid: false, errorLabel: 'Enter Valid Name', error: ''},
  company: {value: '', valid: false, errorLabel: 'Enter Valid Company', error: ''},
  email: {value: '', valid: false, errorLabel: 'Enter Valid Email', error: ''},
  mobile_no: {value: '', valid: false, errorLabel: 'Enter Valid Mobile No.', error: ''},
  emp_count: {value: '', valid: false, errorLabel: 'Enter Valid Employee Count', error: ''},
  contact_through: {value: {value: "talk_to_sales", label: "Talk to Sales"}, valid: true, error: ''},
  message: {value: '', valid: true, errorLabel: 'Enter Valid Message', error: ''},
  agree_to_comunicate: {value: '', valid: true, error: ''}
};
const ContactUs = () => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [contactUsField, setcontactUsField] = React.useState({...fields});
  const [formValid, setFormValid] = React.useState(false);

  const handleClickOpen = () => {
    let data = {};
    data['contactUsArray'] = {};
    for (let key in contactUsField) {
      if(key=='contact_through'){
        data['contactUsArray'][key] = contactUsField[key]['value'].value;
      }else {
        data['contactUsArray'][key] = contactUsField[key].value;
      }
    }
    data['action'] = 'create';
    ApiPostData('api/websiteApi.php', 'contactUsRequest', data).then(result => {
      window.location.href=`${BaseLink}${BaseServerWebsite}contactUsThankYou`;
    });
  };


  const blurInField = (e, fieldname, validationType) => {
    let updateForm = {...contactUsField};
    let formValidVar = true;
    let updateFormField = updateForm[fieldname];

    switch (fieldname) {
      case 'agree_to_comunicate':
        updateFormField.value = e.target.value;
        break;
      case 'contact_through':
        break;
      default:
        updateFormField.value = e.target.value;
        updateFormField.valid = commonValidation(e.target.value, validationType);
        break;
    }
    updateForm[fieldname] = updateFormField
    if (!updateForm[fieldname].valid) {
      updateFormField.error = updateFormField.errorLabel;
    } else {
      updateFormField.error = '';
    }
    for (let key in updateForm) {
      formValidVar = updateForm[key].valid && formValidVar;
    }
    setcontactUsField(updateForm);
    setFormValid(formValidVar);

  }

  const changeInField = (e, fieldname) => {
    let updateForm = {...contactUsField};

    let updateFormField = updateForm[fieldname];
    if(fieldname =='contact_through'){
      updateFormField.value=e;
    }else{
      updateFormField.value = e.target.value;
    }

    let formValidVar = true;
    updateForm[fieldname] = updateFormField
    for (let key in updateForm) {
      formValidVar = updateForm[key].valid && formValidVar;
    }
    setFormValid(formValidVar);
    setcontactUsField(updateForm);
  }

  const changeMobile = (value, ext) => {
    let reqValue = value.replace(ext.dialCode, '');
    reqValue = reqValue.replace('-', '');
    reqValue = parseInt(reqValue.replace('+', ''));
    let updateForm = {...contactUsField};

    let updateFormField = updateForm['mobile_no'];
    updateFormField.value = value;
    if (!isNaN(reqValue) && reqValue !== '') {
      updateFormField.valid = commonValidation(reqValue, {required: true, validationType: 'mobile'});
    } else {
      updateFormField.valid = false;
    }
    let formValidVar = true;
    updateForm['mobile_no'] = updateFormField
    for (let key in updateForm) {
      formValidVar = updateForm[key].valid && formValidVar;
    }
    setFormValid(formValidVar);
    setcontactUsField(updateForm);
  }
  const animatedComponents = makeAnimated();
  return (
    <MuiThemeProvider theme={theme}>
      <Box className={classes.root} pt={1} px={3}>
        <img src={SyncOffice} alt='SyncOffice' style={{height: 100}}/>
        <Paper className={classes.paper}>
          <Typography variant="h5" color='textPrimary' style={{marginBottom: 20}}>
            Contact Us
          </Typography>

          <form className={classes.form} noValidate autoComplete="off">

            <Grid container spacing={2}>
              <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <TextField
                  required
                  label='Contact Name'
                  variant='outlined'
                  size='small'
                  fullWidth
                  className={classes.customTextField}
                  value={contactUsField['name']['value']}
                  onChange={(event) => changeInField(event, 'name',)}
                  onBlur={(event) => blurInField(event, 'name', {required: true, validationType: 'alphanumericsplchr'})}
                />
                {!contactUsField['name'].valid ?
                  <div className={classes.errorStyle}>
                    <Typography variant="caption" style={{color: 'red'}}>
                      {contactUsField['name'].error}
                    </Typography>
                  </div>
                  :
                  <span></span>
                }

              </Grid>

              <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <TextField
                  required
                  label='Company'
                  variant='outlined'
                  size='small'
                  fullWidth
                  className={classes.customTextField}
                  value={contactUsField['company'].value}
                  onChange={(event) => changeInField(event, 'company')}
                  onBlur={(event) => blurInField(event, 'company', {required: true, validationType: 'alphanumericsplchr'})}
                />
                {!contactUsField['company'].valid ?
                  <div className={classes.errorStyle}>
                    <Typography variant="caption" style={{color: 'red'}}>
                      {contactUsField['company'].error}
                    </Typography>
                  </div>
                  :
                  <span></span>
                }
              </Grid>


              <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <TextField
                  label='Email'
                  variant='outlined'
                  size='small'
                  type='email'
                  required
                  className={classes.customTextField}
                  fullWidth
                  onChange={(event) => changeInField(event, 'email')}
                  onBlur={(event) => blurInField(event, 'email', {required: true, validationType: 'email'})}
                />
                {!contactUsField['email'].valid ?
                  <div className={classes.errorStyle}>
                    <Typography variant="caption" style={{color: 'red'}}>
                      {contactUsField['email'].error}
                    </Typography>
                  </div>
                  :
                  <span></span>
                }

              </Grid>

              <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <div className={classes.phoneInput}>
                  <PhoneInput
                    name="Phone"
                    country={'in'}
                    value={contactUsField['mobile_no'].value}
                    onChange={changeMobile}
                    countryCodeEditable={false}
                    enableSearch={true}
                    searchPlaceholder="Search"
                  />
                  <Box style={{top: '-12px', position: 'absolute'}}>
                    <Typography className={classes.phoneTextLabel} variant="caption">Phone *</Typography>
                  </Box>
                </div>
                {!contactUsField['mobile_no'].valid ?
                  <div className={classes.errorStyle}>
                    <Typography variant="caption" style={{color: 'red'}}>
                      {contactUsField['mobile_no'].error}
                    </Typography>
                  </div>
                  :
                  <span></span>
                }

              </Grid>

              <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <TextField
                  label='Number of Employees'
                  variant='outlined'
                  size='small'
                  required
                  fullWidth
                  className={classes.customTextField}
                  value={contactUsField['emp_count'].value}
                  onChange={(event) => changeInField(event, 'emp_count')}
                  onBlur={(event) => blurInField(event, 'emp_count', {required: true, validationType: 'number'})}
                />
                {!contactUsField['emp_count'].valid ?
                  <div className={classes.errorStyle}>
                    <Typography variant="caption" style={{color: 'red'}}>
                      {contactUsField['emp_count'].error}
                    </Typography>
                  </div>
                  :
                  <span></span>
                }

              </Grid>

              <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <div  className={classes.multiselect+ ' d-flex align-items-center'} >
                  <div className="w-100">
                    <div>
                      <Typography variant="caption" color="textSecondary" display="block" className="multiSelectLabel">
                        How can we help you *
                      </Typography>
                    </div>
                    <Select
                      label="How can we help you"
                      value={contactUsField['contact_through'].value}
                      onChange={(event) => changeInField(event, 'contact_through')}
                      onBlur={(event) => blurInField(event, 'contact_through', {required: true, validationType: 'number'})}
                      options={contactTroughOption}
                    />
                  </div>
                </div>



                {!contactUsField['contact_through'].valid ?
                  <div className={classes.errorStyle}>
                    <Typography variant="caption" style={{color: 'red'}}>
                      {contactUsField['contact_through'].error}
                    </Typography>
                  </div>
                  :
                  <span></span>
                }

              </Grid>

              <Grid item xs={12}>
                <TextField
                  label='Your Message'
                  variant='outlined'
                  size='small'
                  fullWidth
                  multiline
                  rowsMax="4"
                  rows="3"
                  className={classes.customTextField}
                  value={contactUsField['message'].value}
                  onChange={(event) => changeInField(event, 'message')}
                  onBlur={(event) => blurInField(event, 'message', {required: false, validationType: 'alphanumericsplchr'})}

                />
                {!contactUsField['message'].valid ?
                  <div className={classes.errorStyle}>
                    <Typography variant="caption" style={{color: 'red'}}>
                      {contactUsField['message'].error}
                    </Typography>
                  </div>
                  :
                  <span></span>
                }

              </Grid>

              <Grid item xs={12} textAlign='left'>

                <FormControlLabel
                  control={<Checkbox color="primary"/>}
                  label={<Typography variant="body2">I consent to receive communications from SyncOffice</Typography>}
                  value={contactUsField['name'].value}
                  onChange={(event) => changeInField(event, 'agree_to_comunicate')}
                />
              </Grid>


            </Grid>

            <Box textAlign="right" mt={2}>

              <a href={`${BaseURL}`} style={{textDecoration:'none'}}>
                <Box mr={2} display="inline">
                <MaterialUiButtons
                  iconName="close"
                  color="#f34225"
                  btnTitle="Cancel"
                  btnSize="small"
                />
                </Box>
              </a>
              <MaterialUiButtons
                iconName="save"
                btnClick={handleClickOpen}
                color="#1b5e20"
                btnTitle="Submit"
                btnDisable={!formValid}
                btnSize="small"
              />
            </Box>

          </form>

        </Paper>

      </Box>
    </MuiThemeProvider>
  );
};

export default ContactUs;
